<template>
  <path
    d="M18.3 14.2902C17.91 13.9002 17.28 13.9002 16.89 14.2902L13 18.1702V3.00024C13 2.45024 12.55 2.00024 12 2.00024C11.45 2.00024 11 2.45024 11 3.00024V18.1802L7.11998 14.3002C6.72998 13.9102 6.09998 13.9102 5.70998 14.3002C5.31998 14.6902 5.31998 15.3202 5.70998 15.7102L11.3 21.3002C11.69 21.6902 12.32 21.6902 12.71 21.3002L18.3 15.7102C18.68 15.3202 18.68 14.6802 18.3 14.2902Z"
  />
</template>
